'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckAuth = undefined;

var _CheckAuth2 = require('./CheckAuth');

var _CheckAuth3 = _interopRequireDefault(_CheckAuth2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CheckAuth = _CheckAuth3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/CheckAuth/index.js
// module id = 1810
// module chunks = 0